export default __webpack_public_path__ + "static/media/perklinks.5bf7fbe1.png";